/* Video Carousel */
(function () {
  'use strict';

  class KlVideoCarousel extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this._setWidth = () => this.style.setProperty('--parent-width', `${this.offsetWidth}px`);
      this._setWidth();
      window.addEventListener('resize', this._setWidth, { signal: this._abortController.signal });

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const source = entry.target.querySelector('[data-src]');

            if (source && source.dataset.src) {
              source.src = source.dataset.src;
              entry.target.load();
              entry.target.play().catch(() => {});
            }

            this._observer.unobserve(entry.target);
          });
        },
        { threshold: 0.1 }
      );

      this.querySelectorAll('[data-video]').forEach((video) => this._observer.observe(video));
    }

    disconnectedCallback() {
      this._abortController.abort();

      if (this._observer) {
        this._observer.disconnect();
      }
    }
  }

  if (!customElements.get('kl-video-carousel')) {
    customElements.define('kl-video-carousel', KlVideoCarousel);
  }
})();
